import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ErrorBoundary } from 'react-error-boundary';

import { ErrorFallback } from 'components';

import reportWebVitals from './reportWebVitals';

import './styles/mytheme/theme.scss';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import './styles/_main.scss';

import { App } from 'modules';
import store from './store';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});

/*
 * Nothing used to catch a render error, so any one of them unmounted the whole
 * tree and left a blank page with no way back. The fallback at least names the
 * failure and offers a reload.
 */
const DOM_NODE = (
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ErrorBoundary FallbackComponent={ErrorFallback}>
          <App />
        </ErrorBoundary>
      </BrowserRouter>

      {/* {process.env.NODE_ENV === 'development' && (
        <ReactQueryDevtools position="bottom-right" initialIsOpen={false} />
      )} */}
    </QueryClientProvider>
  </Provider>
);

console.log(process.env.NODE_ENV);

const container = document.getElementById('root');

const root = createRoot(container!);

root.render(DOM_NODE);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
